import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
    { label: "Accueil", href: "/", isRoute: true },
    { label: "Nos montures", href: "/montures", isRoute: true },
    { label: "Nos services", href: "/services", isRoute: true },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const renderLink = (l, mobile = false) => {
        const isActive =
            l.isRoute && location.pathname === l.href && l.href !== "/";
        const className = mobile
            ? "font-header text-2xl font-semibold text-lpl-text hover:text-lpl-primary-deep py-2"
            : `px-4 py-2 font-header text-sm font-medium transition-colors ${
                  isActive
                      ? "text-lpl-primary-deep"
                      : "text-lpl-text hover:text-lpl-primary-deep"
              }`;
        const testId = `nav-link${mobile ? "-mobile" : ""}-${l.label
            .toLowerCase()
            .replace(/\s+/g, "-")}`;
        if (l.isRoute) {
            return (
                <Link
                    key={l.href}
                    to={l.href}
                    onClick={() => mobile && setOpen(false)}
                    className={className}
                    data-testid={testId}
                >
                    {l.label}
                </Link>
            );
        }
        return (
            <a
                key={l.href}
                href={l.href}
                onClick={() => mobile && setOpen(false)}
                className={className}
                data-testid={testId}
            >
                {l.label}
            </a>
        );
    };

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-lpl-bg ${
                scrolled
                    ? "backdrop-blur-md border-b border-lpl-border shadow-sm"
                    : ""
            }`}
            data-testid="navbar"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-4 flex items-center justify-between">
                <Link
                    to="/"
                    className="font-header text-xl md:text-2xl font-semibold text-lpl-text leading-tight flex items-baseline gap-2"
                    data-testid="nav-logo"
                >
                    <span>
                        La Petite{" "}
                        <span className="text-lpl-primary">Lunetterie</span>
                        <span className="text-lpl-lavender">.</span>
                    </span>
                    <span className="hidden sm:inline text-[11px] uppercase tracking-[0.22em] font-semibold text-lpl-text-muted">
                        Opticien indépendant
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-2">
                    {links.map((l) => renderLink(l, false))}
                    <Link
                        to="/contact"
                        data-testid="nav-cta"
                        className="ml-3 px-5 py-2.5 bg-lpl-primary text-lpl-text rounded-full font-header text-sm font-medium hover:bg-lpl-text hover:text-lpl-bg transition-colors"
                    >
                        Nous trouver
                    </Link>
                </nav>

                <button
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden p-2 text-lpl-text"
                    aria-label="Menu"
                    data-testid="nav-toggle-mobile"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    className="md:hidden bg-lpl-bg border-t border-lpl-border"
                    data-testid="nav-mobile-menu"
                >
                    <div className="px-5 py-5 flex flex-col gap-1">
                        {links.map((l) => renderLink(l, true))}
                    </div>
                </div>
            )}
        </header>
    );
}
